import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import CustomerList from "../Customer/CustomerList";
import KycList from "../KycList/KycLIst";
import InactiveCustomer from "../Customer/InactiveCustomer";
import Blocklist from "../BlockList/Blocklist";
import { canShowPermission } from "../Permissions/permissionObject";
import { useEffect } from "react";
import InfoButton from "../../Comman/InfoButton";

export default function CustomersPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewAllCustomers = canShowPermission(permissions, "allCustomers", "view");
  const canViewKycVerfication = canShowPermission(permissions, "kycVerification", "view");
  const canViewInactiveCustomers = canShowPermission(permissions, "inactiveCustomer", "view");
  const canViewBlockCustomers = canShowPermission(permissions, "blockCustomer", "view");

  const tabs = [
    canViewAllCustomers && {
      label: t("tabs.allCustomers"),
      content: <CustomerList />
    },
    canViewKycVerfication && {
      label: t("tabs.kycCustomers"),
      content: <KycList />
    },
    canViewInactiveCustomers && {
      label: t("tabs.inactiveCustomers"),
      content: <InactiveCustomer />
    },
    canViewBlockCustomers && {
      label: t("tabs.blockCustomers"),
      content: <Blocklist />
    }
  ]
  .filter(Boolean);



  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Paper
          sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
          elevation={1}
        >
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="fullWidth"
            sx={{
              mb: 0,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              padding: "4px",
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "16px",
                textTransform: "none",
                borderRadius: "6px",
                margin: "0 4px",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#7A3FFF",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderBottom: "3px solid #7A3FFF",
                },
                "&:hover": {
                  backgroundColor: "rgba(122, 63, 255, 0.08)",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
          <Box sx={{ mt: 0 }}>
            {tabs[tabIndex]?.content}
          </Box>
        </Paper>
      </Box>
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="CUSTOMER" />
  </Box>
    </Box>
  </Box>
  );
}

